import React from "react";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";
import { useSnapshot } from "valtio";
import { store as userStore } from "@components/VerticalLayout/store";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { useFetchGlobal } from "../../../../../api/hooks";
import moment from "moment";
import { showSuccessToast } from "@components/Common/SuccessToast";
import ErrorToast from "@components/Common/ErrorTost";

type CardFooterListShopType = {
    dataListShops: any;
    rowData: any;
    setIsModalAssociateStore: Function;
    isModalAssociateStore: boolean;
    setIsDataUpdated: React.Dispatch<React.SetStateAction<number | boolean>>;
};

export default function CardFooterListShop({
    dataListShops,
    rowData,
    setIsModalAssociateStore,
    isModalAssociateStore,
    setIsDataUpdated,
}: CardFooterListShopType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { userID, franchiseID, operatorID } = useSnapshot(userStore);

    async function handleValidateButtonClickEvent() {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/projects/pos/associate/shops`;

        // Build shop data map
        const dataShop: Record<string, any> = {};
        for (const el of dataListShops) {
            dataShop[el.id_boutique] = {
                designation: el[t("Shop")],
                id_boutique: el.id_boutique,
            };
        }

        // Build shop IDs list
        const shopIds: string[] = dataListShops.map(
            (el: any) => el.id_boutique
        );

        const projectId = rowData.projectId;
        const idProject = "PROJECT";
        const now = moment();

        const savedData = {
            userId: userID,
            uuidUser: localStorage.getItem("uuidUser"),
            franchiseId: franchiseID,
            project_id: idProject,
            projectId,
            operatorId: operatorID,
            shopId: shopIds,
            associates: dataShop,
            type: "Add",
            modified_at: now.format("DD/MM/YYYY [at] HH:mm a"),
            hour: now.format("DD/MM/YY - HH:mm a"),
            projectData: {
                designation: rowData[t("Designation")],
                note: rowData[t("Note")],
                status: rowData[t("Status")],
            },
        };

        try {
            const data: any = await fetchGlobal(apiUrl, {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(savedData),
                method: "POST",
            });
            mutate(apiUrl, data);
            if (data.error) {
                throw Error("Error while saving selection!");
            }
            showSuccessToast(t("Store assignment was successful")!);
            setIsModalAssociateStore(!isModalAssociateStore);
            setIsDataUpdated(true);
        } catch (e: any) {
            ErrorToast(`${t("Mistake ! Please try again")}!`);
        }
    }

    return (
        <div>
            <div className="justify-content-between d-flex align-items-right float-right p-3 mt-3">
                <CustomSecondaryColorButton
                    outline
                    rounded
                    className="mr-2 cmn_btn_cancelAlert"
                    variant="light"
                    onClick={() => {
                        setIsModalAssociateStore(!isModalAssociateStore);
                    }}
                >
                    <span> {t("Cancel")}</span>
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    variant="primary"
                    className="cmn_btn_validateAlert"
                    onClick={handleValidateButtonClickEvent}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </div>
        </div>
    );
}
